import type { DeviceViewEdgeEntity } from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

export interface ShowEdgeDetailCommand {
  entity: DeviceViewEdgeEntity;
}

export const showEdgeDetail: DeviceViewCommandFactory<ShowEdgeDetailCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.deviceViewOpen = true;
      draft.activeDeviceViewEntityId = command.entity.id;
      if (
        !draft.deviceViewEntities.some(
          (entity) => entity.id === command.entity.id,
        )
      ) {
        draft.deviceViewEntities.unshift(command.entity);
      }
    });
  };
